import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ServiceUsageCardCmp_Service_Fragment = graphql(`
  fragment ServiceUsageCardCmp_Service_Fragment on Service {
    _id
    __typename
    title
    value {
      discountAmount {
        value
        currencyId
      }
      discountPercentage
      priceExcludingVat {
        value
        currencyId
      }
      vatId
    }
    code
    codingConfig {
      ...CodeCmp_CodingConfig_Fragment
    }
    content
    costUsages {
      costId
      index
      quantity {
        value
        unitId
      }
    }
    label
    materialUsages {
      materialId
      index
      quantity {
        value
        unitId
      }
    }
  }
`);

export type ServiceUsageCardCmp_Service = ResultOf<
  typeof ServiceUsageCardCmp_Service_Fragment
>;
